export const fileSizeRegex = /(\d+\.?\d*)\s*([KMGTP]?B)/i;

const sizeUnits = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
const thresh = 1000;

export function readableFileSize(bytes: number, dp = 1) {
  if (Math.abs(bytes) < thresh) {
    return `${bytes}B`;
  }

  let u = 0;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < sizeUnits.length - 1);

  return bytes.toFixed(dp) + sizeUnits[u];
}

export function parseFileSize(size: string | undefined) {
  if (!size) {
    return 0;
  }

  const match = size.match(fileSizeRegex);

  if (!match || match.length !== 3) {
    return 0;
  }

  const value = Number.parseFloat(match[1] ?? '0');
  const unit = match[2]?.toUpperCase() ?? 'B';

  return value * thresh ** sizeUnits.indexOf(unit);
}
